"use client";
import SectionPage from "@/components/common/section-page";
import EspaceProTitleCard from "@/components/common/espace-pro-title-card";

export default function Home() {

    return (
        <div className={"flex flex-col gap-6 pb-6 mb-8"}>


            <EspaceProTitleCard title={"Budget, Finances et Moyens Généraux"}
                                middleBreadcrumbs={[
                                    {title: "L'Office du Tourisme", link: "/espace-pro/office-de-tourisme"},
                                ]}
                                description={"Découvrez l’équipe de l’Office de Tourisme et les missions que nous menons, en faveur du développement touristique de la destination COTE D’IVOIRE"}/>

            {/* Nature & Biodiversité */}
            <SectionPage sectionType="lg">

                <p className={"text-normal mb-8"}>
                    Directeur : Monsieur <strong>KAMBRI Joachim</strong>
                    <br/>
                    <br/>
                    Il est chargé de :
                </p>

                <div className={"text-normal mb-8"}>
                    <ul className="list-disc list-inside text-lg mt-8">
                        <li className="li2">Préparer le projet de budget de Côte d’Ivoire Tourisme ;</li>
                        <li className="li2">Préparer les opérations d’exécution du budget, l’engagement, la liquidation
                            et notamment l’ordonnancement ;
                        </li>
                        <li className="li2">Établir l’état mensuel d’exécution du budget ;</li>
                        <li className="li2">Gérer la paie du personnel ;</li>
                        <li className="li2">Préparer les marchés, baux et conventions ;</li>
                        <li className="li2">Tenir la comptabilité administrative ;</li>
                        <li className="li2">Gérer le matériel et le patrimoine de Côte d’Ivoire Tourisme.</li>
                    </ul>
                </div>

            </SectionPage>

        </div>
    );
}
